module.exports = __webpack_public_path__ + "static/facebook-ca1eabc06e75c52478b9d02b30312d17.png";